(function() {
    'use strict';

    angular
        .module('papp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('price', {
            abstract: true,
            parent: 'app'
        });
    }
})();
